import type { ReactNode } from 'react';

export const symbol_align_justify_flex_start: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M109.82-80Q97-80 88.5-88.63 80-97.25 80-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM560-290q-12.75 0-21.37-8.63Q530-307.25 530-320v-320q0-12.75 8.63-21.38Q547.25-670 560-670h40q12.75 0 21.38 8.62Q630-652.75 630-640v320q0 12.75-8.62 21.37Q612.75-290 600-290h-40Zm-240 0q-12.75 0-21.37-8.63Q290-307.25 290-320v-320q0-12.75 8.63-21.38Q307.25-670 320-670h40q12.75 0 21.38 8.62Q390-652.75 390-640v320q0 12.75-8.62 21.37Q372.75-290 360-290h-40Z"
		/>
	</svg>
);
